import type { SpinWheelTranslationEntity } from './SpinWheelTranslationEntity'

export class SpinWheelEntity {
  id?: number
  validFrom?: string
  validTo?: string
  minOrdersCount?: number
  translations?: Array<SpinWheelTranslationEntity> | null
  isPrimary?: boolean
  priority?: number
}
